import React, { Fragment } from 'react';
import { componentDispatcher } from './_componentDispatcher';

import AnchorLinks from '../anchorLinks/AnchorLinks';
import ApiPerformanceData from '../apiPerformanceData/ApiPerformanceData';
import AppIntentFallBackSection from '../appIntentFallBackSection/AppIntentFallBackSection';
import AwardsBanner from '../awardsBanner/AwardsBanner';
import BannerHeader from '../bannerHeader/BannerHeader';
import Banner from '../banner/Banner';
import BlockQuote from '../blockQuote/BlockQuote';
import Blocks from '../blocks/Blocks';
import Block from '../block/Block';
import BlogFooter from '../blogFooter/BlogFooter';
import BlogPostGrid from '../blogPostGrid/BlogPostGrid';
import BrandsCarousel from '../brandsCarousel/BrandsCarousel';
import CampaignQuote from '../../components/campaignQuote/CampaignQuote';
import Card from '../card/Card';
import Columns from '../columns/Columns';
import CopyBox from '../copyBox/CopyBox';
import CTABanner from '../ctaBanner/CTABanner';
import CTABlock from '../ctaBlock/CTABlock';
import CTAButton from '../ctaButton/CTAButton';
import CurrencyCalculator from '../currencyCalculator/CurrencyCalculator';
import DefaqtoCustomTable from '../defaqtoCustomTable/DefaqtoCustomTable';
import DeprecatedGrid from '../deprecatedGrid/DeprecatedGrid';
import Disclaimer from '../disclaimer/Disclaimer';
import Divider from '../divider/Divider';
import DownloadForm from '../downloadForm/DownloadForm';
import Drawer from '../drawer/Drawer';
import EcbCalculator from '../ecbCalculator/EcbCalculator';
import Embed from '../embed/Embed';
import EmbeddableTweet from '../embeddableTweet/EmbeddableTweet';
import FeaturedContent from '../featuredContent/FeaturedContent';
import FeaturedVideoContent from '../featuredVideoContent/FeaturedVideoContent';
import FilteredBlogPostGrid from '../filteredBlogPostGrid/FilteredBlogPostGrid';
import FluidColumns from '../fluidColumns/FluidColumns';
import Gallery from '../gallery/Gallery';
import Glossary from '../glossary/Glossary';
import HeaderBlock from '../headerBlock/HeaderBlock';
import Image from '../image/Image';
import ImageBlocks from '../imageBlocks/ImageBlocks';
import IconBlock from '../iconBlock/IconBlock';
import IconBlocks from '../iconBlocks/IconBlocks';
import IconsList from '../iconsList/IconsList';
import IconsCarousel from '../iconsCarousel/IconsCarousel';
import FixedTermInterestCalculator from '../fixedTermInterestCalculator/FixedTermInterestCalculator';
import List from '../list/List';
import LoansCalculator from '../loansCalculator/LoansCalculator';
import LoanRepaymentCalculator from '../loanRepaymentCalculator/LoanRepaymentCalculator';
import Lottie from '../lottie/Lottie';
import NewsPostGrid from '../newsPostGrid/NewsPostGrid';
import NumberDivider from '../numberDivider/NumberDivider';
import OverdraftCalculator from '../overdraftCalculator/OverdraftCalculator';
import Pill from '../pill/Pill';
import PreviewCustomTable from '../previewCustomTable/PreviewCustomTable';
import Quote from '../quote/Quote';
import Reports from '../reports/Reports';
import ReferralsForm from '../referralsForm/ReferralsForm';
import ReferralsFormAccountants from '../referralsFormAccountants/ReferralsFormAccountants';
import OnboardingCta from '../onboardingCta/OnboardingCta';
import Section from '../section/Section';
import ShareLinks from '../shareLinks/ShareLinks';
import SmeLendingForm from '../smeLendingForm/SmeLendingForm';
import SmeToolkit from '../smeToolkit/SmeToolkit';
import SortCodeChecker from '../sortCodeChecker/SortCodeChecker';
import Stats from '../stats/Stats';
import StepsJCA from '../stepsJCA/StepsJCA';
import StudentAccordion from '../studentAccordion/StudentAccordion';
import TaxTool from '../taxTool/TaxTool';
import TextContent from '../textContent/TextContent';
import TextWithBackground from '../textWithBackground/TextWithBackground';
import Tutorial from '../tutorial/Tutorial';
import Tooltip from '../tooltip/Tooltip';
import TravelHero from '../travelHero/TravelHero';
import TrustpilotCarousel from '../trustpilotCarousel/TrustpilotCarousel';
import Grid, { GridItem } from '../grid/Grid';
import Wrapper from '../wrapper/Wrapper';

const BusinessSupport = React.lazy(() => import('../businessSupport/BusinessSupport'));
const CurrentJobOpenings = React.lazy(() => import('../currentJobOpenings/CurrentJobOpenings'));
const InteractiveQuiz = React.lazy(() => import('../interactiveQuiz/InteractiveQuiz'));
const OverdraftEligibility = React.lazy(() => import('../overdraftEligibility/OverdraftEligibility'));
const Partners = React.lazy(() => import('../partners/Partners'));
const PostOfficeFinderGrid = React.lazy(() => import('../postOfficeFinderGrid/PostOfficeFinderGrid'));
const TravelTool = React.lazy(() => import('@starlingbank/travel-tool'));
const BusinessProductComparisonTool = React.lazy(() => import('@starlingbank/business-product-comparison-tool'));
const OnboardingForm = React.lazy(() => import('../onboardingForm/OnboardingForm'));

const CustomTable = React.lazy(() => import('../customTable/CustomTable'));

const components = {
  AnchorLinks,
  ApiPerformanceData,
  AppIntentFallBackSection,
  AwardsBanner,
  BannerHeader,
  Banner,
  BlockQuote,
  Blocks,
  Block,
  BlogFooter,
  BlogPostGrid,
  BrandsCarousel,
  BusinessProductComparisonTool,
  BusinessSupport,
  CampaignQuote,
  Card,
  Columns,
  CopyBox,
  CTABlock,
  CTAButton,
  CTABanner,
  CurrencyCalculator,
  CurrentJobOpenings,
  CustomTable,
  DefaqtoCustomTable,
  DeprecatedGrid,
  Disclaimer,
  Divider,
  DownloadForm,
  Drawer,
  EcbCalculator,
  Embed,
  EmbeddableTweet,
  FeaturedContent,
  FeaturedVideoContent,
  FilteredBlogPostGrid,
  FluidColumns,
  Gallery,
  Glossary,
  HeaderBlock,
  Image,
  ImageBlocks,
  IconBlock,
  IconBlocks,
  InteractiveQuiz,
  FixedTermInterestCalculator,
  IconsList,
  IconsCarousel,
  List,
  LoanRepaymentCalculator,
  LoansCalculator,
  Lottie,
  NewsPostGrid,
  NumberDivider,
  OnboardingCta,
  OnboardingForm,
  OverdraftEligibility,
  OverdraftCalculator,
  Partners,
  PostOfficeFinderGrid,
  Pill,
  PreviewCustomTable,
  Quote,
  Reports,
  ReferralsForm,
  ReferralsFormAccountants,
  Section,
  ShareLinks,
  SmeLendingForm,
  SmeToolkit,
  SortCodeChecker,
  Stats,
  StepsJCA,
  StudentAccordion,
  TaxTool,
  TextContent,
  TextWithBackground,
  Tooltip,
  Tutorial,
  TravelHero,
  TravelTool,
  TrustpilotCarousel,
  Grid,
  GridItem,
  Wrapper
};

function ComponentDispatcher({ source, meta, content, assets, pathName, injectComponents }) {
  const children = componentDispatcher({
    components: { ...components, ...injectComponents },
    source,
    meta,
    content,
    assets,
    pathName
  });
  return <Fragment {...{ children }} />;
}

export default ComponentDispatcher;
